/**
 * @fileoverview Directory option query keys.
 * @description The query keys of the option lists in directory-options.service.ts. Every feature
 * that reads one uses the key here, so the same list is fetched once and shared from the cache
 * rather than once per feature. The keys sit under the prefixes the features invalidate: the
 * eligible managers under `['users']`, the prospect metadata under `['sales', 'crm']`.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

export const ASSIGNABLE_ROLES_QUERY_KEY = [
  'authorization',
  'assignable-roles',
  'INVITATION',
] as const

export const PROSPECT_METADATA_QUERY_KEY = ['sales', 'crm', 'metadata'] as const

/** The prefix of every role's eligible reporting managers, to refresh them all at once. */
export const ELIGIBLE_REPORTING_MANAGERS_QUERY_KEY = [
  'users',
  'eligible-reporting-managers',
] as const

/**
 * @description The key of one role's eligible reporting managers.
 * @param {string} targetRoleId - The role the user will have.
 * @returns {readonly string[]} The query key.
 */
export function eligibleReportingManagersQueryKey(targetRoleId: string) {
  return [...ELIGIBLE_REPORTING_MANAGERS_QUERY_KEY, targetRoleId] as const
}
